import React from 'react';
// import { useLocation } from 'react-router-dom';
import { AiFillCheckCircle } from 'react-icons/ai';
import { List } from 'antd';
import mainMitraLogo from '../../assets/mitra-main-logo.png';
import BottomButton from '../Buttons/BottomButton';
import { MARKETPLACE_CONSTANTS } from '../../constants/MarketplaceConstants';
// import {
//   getUserDetailsById,
//   updateMarketplaceUserDetails,
// } from '../../services/API/MarketplaceService';
// import { Routes } from '../../constants/RouterConstants';
// import { Navigation } from '../../services/NavigationService';

const { WELCOME_CONDITIONS } = MARKETPLACE_CONSTANTS;

const WelcomeHeader = () => {
  return (
    <div className="heading-cont disp-flex-col aic">
      <div className="heading-img-div">
        <img className="heading-img" src={mainMitraLogo} alt="mitraLogo" />
      </div>
      <h2 style={{ color: '#D34B18', fontWeight: 'bold', fontSize: '2em' }}>Welcome To Mitra</h2>
      <p style={{ textAlign: 'center', color: '#D34B18', fontSize: '1.1em' }}>
        Your friend to help you find the best job!
      </p>
    </div>
  );
};

const WelcomeConditions = () => {
  return (
    <List>
      {WELCOME_CONDITIONS.map(item => (
        // eslint-disable-next-line react/jsx-key
        <List.Item
          key={item}
          className="border-0"
          style={{ fontFamily: 'Open Sans', marginBottom: '1em', fontSize: '1.25em' }}
        >
          <span>
            <AiFillCheckCircle color="#00964B" style={{ marginRight: 7 }} />
          </span>
          {item}
        </List.Item>
      ))}
    </List>
  );
};

// function useQuery() {
//   const { search } = useLocation();
//   return React.useMemo(() => new URLSearchParams(search), [search]);
// }

const WelcomeScreen = () => {
  // const history = useHistory();
  // const query = useQuery();
  // const [loading, setLoading] = useState(true);
  // const userId = query.get('userId');
  // const gotoMarketplaceSelectCity = () => {
  //   localStorage.setItem('userId', userId);
  //
  //   const citySelectionRoute = {
  //     pathname: Routes.SELECT_CITY_WISE_JOBS,
  //   };
  //
  //   getUserDetailsById(userId)
  //     .then(response => {
  //       if (response.status === 200) {
  //         return response.data;
  //       }
  //     })
  //     .then(responseObj => {
  //       if (responseObj?.jobseekerCityPreference) {
  //         const preferredLocation = responseObj?.jobseekerCityPreference;
  //         const jobListingsRoute = {
  //           pathname: Routes.JOB_LISTINGS,
  //           search: `city=${preferredLocation}`,
  //         };
  //         localStorage.setItem('preferredLocation', preferredLocation);
  //         Navigation.push(jobListingsRoute);
  //       } else {
  //         Navigation.push(citySelectionRoute);
  //       }
  //     })
  //     .catch(error => {
  //       console.log(error);
  //       Navigation.push(citySelectionRoute);
  //     });
  // };
  const saveWelcomeScreenCount = () => {
    window.location.href = 'https://mitraapp.page.link/playstore';
  };

  // useEffect(() => {
  //   setLoading(true);
  //   getUserDetailsById(userId)
  //     .then(response => {
  //       if (response?.status === 200) {
  //         return response?.data;
  //       }
  //     })
  //     .then(responseObj => {
  //       if (responseObj?.jobseekerCityPreference) {
  //         localStorage.setItem('userId', userId);
  //         localStorage.setItem('preferredLocation', responseObj?.jobseekerCityPreference);
  //         if (
  //           responseObj?.jobseekerWelcomeScreenCount &&
  //           responseObj?.jobseekerWelcomeScreenCount > MIN_WELCOME_SCREEN_COUNT
  //         ) {
  //           const route = {
  //             pathname: Routes.JOB_LISTINGS,
  //             search: `city=${responseObj?.jobseekerCityPreference}`,
  //           };
  //           Navigation.push(route);
  //           // history.replace(`/job-listings?city=${responseObj?.jobseekerCityPreference}`);
  //         } else setLoading(false);
  //       } else setLoading(false);
  //     })
  //     .catch(error => {
  //       setLoading(false);
  //       console.log(error);
  //     });
  // }, [userId]);
  return (
    <div className="m-4" style={{ overflow: 'auto', paddingBottom: '3em' }}>
      <WelcomeHeader />
      <hr />
      <WelcomeConditions />
      <BottomButton buttonText="Download" callBackFunction={saveWelcomeScreenCount} />
    </div>
  );
};

export default WelcomeScreen;
